export interface AlarmSummaryDto {
    id: string;
    objectId: string;
    modelId: string;
    propertyName: string;
    message: string;
    messageValues: KeyValuePair[];
    onTime: Date;
    //onMessage: string;
    offTime: Date | null;
    //offMessage: string | null;
    ackUser: string | null;
    ackUserId: string | undefined;
    ackTime: Date | null;
    duration?: number
    resourceGroupId: string
}

export interface KeyValuePair {
    key: string,
    value: any
}


export interface AlarmDetailsDto extends AlarmSummaryDto {

    object: AlarmObjectDto,
    alarmClass: AlarmClassDto,
}

export interface AlarmObjectDto {
    id: string;
    name: string;
    //schema: string;
    description: string;
    resourceGroupId: string,
}

export interface AlarmClassDto {
    id: string;
    name: string;
    priority: number;
    //iconUrl: string;
    onBehavior: AlarmBehaviorDto;
    offBehavior: AlarmBehaviorDto;
    ackedBehavior: AlarmBehaviorDto;
}

export interface AlarmBehaviorDto {
    ackNecessary: boolean;
    //foregroundColor: string;
    //backgroundColor: string;
}

export enum AlarmEventState
{
    Created,
    Updated,
    Deleted
}

export interface AlarmNotification {
    state: AlarmEventState,
    alarm: AlarmSummaryDto,
}

export interface GetAllAlarmsArgs {
    timeFrom: string,
    timeTo: string,
}

export interface AckAlarmArgs {
    alarmId: string,
    resourceGroupId: string,
}

export interface GetAlarmByIdArgs {
    alarmId: string,
    resourceGroupId: string,
}

export interface GetObjectAlarmsArgs {
    objectId: string,
    resourceGroupId: string,
    includeChildren: boolean
}